import React, { useRef, useEffect } from 'react'
import globals from '../globals'
import { connect } from 'react-redux'
import HomeSecureSubscribeModule from '../modules/HomeSecureSubscribeModule'

const SubscribeToHomeSecure = (props) => {
    const container = useRef(null)

    useEffect(() => {
        if (container) {
            globals.animatePageIn(container.current)
        }
    }, [])

    return (
        <div ref={container} style={{ opacity: 0 }}>
            <div className='module service-row-notification align-items-center p-4 pr-lg-5 d-none d-lg-flex'>
                <img src='/images/home-secure/home-secure-logo.svg' alt='Icon' height='55px' className='mr-4 mr-lg-5' />
                <p
                    className='m-0 lh'
                    dangerouslySetInnerHTML={{ __html: globals.noWidows('Keep your family safer and better protected from internet baddies and unwanted content with Exetel Home Secure. Nothing to download, just subscribe here, manage your settings, and you are sorted.') }}
                />
            </div>
            <HomeSecureSubscribeModule serviceId={props.match.params.id ? parseInt(props.match.params.id) : null} />
        </div>
    )
}

const mapStateToProps = state => ({
    customerId: state.auth.id
})

export default connect(mapStateToProps)(SubscribeToHomeSecure)



// WEBPACK FOOTER //
// ./resources/js/pages/SubscribeToHomeSecure.js